/* KrakenTheMeta dashboard — Home: the AI composer front and centre, then recent decks,
 * a few numbers, the Pro card and the latest Arena games.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;

  var PLACEHOLDERS = [
    "A mono-green stompy deck for Pioneer, as fast as possible",
    "Budget Atraxa superfriends, under $150",
    "Izzet spells for Standard that burns people out",
    "A Krenko goblins deck from cards I already own",
    "Pauper faeries with plenty of counterspells"
  ];

  // the husk sweep (or any change to the deck list) refreshes the recent decks in place: a full
  // re-render would wipe a half-typed prompt and close any open sheet
  var repaint = null;
  document.addEventListener("kd:decks", function () { if (repaint) repaint(); });

  KD.routes.home = function (view) {
    repaint = function () {
      if (KD.parseRoute().name !== "home" || !KD.$("[data-recent]", view)) return;
      paintRecent(view);
      var t = KD.$('[data-t="decks"]', view);
      if (t) t.textContent = KD.fmt(S.decks.length);
    };
    var first = String(S.user.displayName || "").split(/\s+/)[0] || "brewer";
    var hour = new Date().getHours();
    var hello = hour < 5 ? "Up late" : hour < 12 ? "Morning" : hour < 18 ? "Afternoon" : "Evening";
    var ph = PLACEHOLDERS[Math.floor(Math.random() * PLACEHOLDERS.length)];

    view.innerHTML =
      '<section class="greet"><p class="depth-tag">Your lair</p><h2>' + hello + ", <em>" + esc(first) + ".</em></h2><p>What are we building today?</p></section>" +
      '<div class="home-grid"><div class="home-main">' +
        '<form class="composer" data-composer>' +
          '<div class="composer__label"><label class="depth-tag" for="homePrompt">Describe a deck</label><span class="gensline" data-gensline></span></div>' +
          '<textarea id="homePrompt" rows="3" maxlength="600" placeholder="' + esc(ph) + '"></textarea>' +
          '<div class="composer__row">' +
            '<div class="seg" role="radiogroup" aria-label="Format" data-formats>' +
              [["commander", "Commander"], ["brawl", "Brawl"], ["standard", "Standard"], ["modern", "Modern"], ["pioneer", "Pioneer"], ["pauper", "Pauper"]].map(function (f, i) {
                return '<button type="button" role="radio" aria-checked="' + (i === 0) + '" aria-selected="' + (i === 0) + '" data-format="' + f[0] + '">' + f[1] + "</button>";
              }).join("") +
            "</div>" +
            '<button class="btn btn--lure composer__go" type="submit">' + KD.icon("sparkle") + "<span>Build with AI</span></button>" +
          "</div>" +
          '<div class="composer__meta"><span>The Kraken reads the live meta, builds every card and checks each one on Scryfall.</span>' +
            '<button class="linkbtn" type="button" data-more-options>More options' + "</button></div>" +
        "</form>" +
        '<div class="quick">' +
          '<button type="button" data-quick="empty">' + KD.icon("layers") + "<span><b>Build by hand</b><small>Start an empty deck</small></span></button>" +
          '<button type="button" data-quick="import">' + KD.icon("download") + "<span><b>Import a list</b><small>Paste from anywhere</small></span></button>" +
          '<button type="button" data-quick="collection">' + KD.icon("box") + "<span><b>Add to collection</b><small>Track the cards you own</small></span></button>" +
        "</div>" +
        '<div class="shead"><h3>Recent decks</h3><a href="#/decks">All decks</a></div>' +
        '<div class="dgrid" data-recent>' + KD.deckSkeletons(4) + "</div>" +
        '<div data-arena-snap></div>' +
      "</div>" +
      '<aside class="home-side">' +
        '<div class="tiles" data-tiles>' +
          '<div class="tile"><b data-t="decks">…</b><span>Decks</span></div>' +
          '<div class="tile"><b data-t="cards">…</b><span>Cards owned</span></div>' +
          '<div class="tile"><b data-t="value">…</b><span>Collection value</span></div>' +
          '<div class="tile"><b data-t="gens">' + (D.gens().unlimited ? "∞" : D.gens().left) + "</b><span>AI builds left</span></div>" +
        "</div>" +
        '<div class="mt-16">' + KD.proCard() + "</div>" +
      "</aside></div>";

    // the composer
    var form = KD.$("[data-composer]", view), ta = KD.$("#homePrompt", view);
    var format = "commander";
    KD.$$("[data-format]", form).forEach(function (b) {
      b.addEventListener("click", function () {
        format = b.dataset.format;
        KD.$$("[data-format]", form).forEach(function (x) { var on = x === b; x.setAttribute("aria-checked", String(on)); x.setAttribute("aria-selected", String(on)); });
      });
    });
    paintGensLine(KD.$("[data-gensline]", view));
    ta.addEventListener("keydown", function (e) { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) form.requestSubmit(); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var prompt = ta.value.trim();
      if (!prompt) { ta.focus(); KD.toast("Describe the deck you want first.", "info"); return; }
      KD.create.start({ prompt: prompt, format: format, opts: {} });
    });
    KD.$("[data-more-options]", view).addEventListener("click", function () {
      KD.create.open({ mode: "ai", prompt: ta.value.trim(), format: format });
    });
    KD.$$("[data-quick]", view).forEach(function (b) {
      b.addEventListener("click", function () {
        var q = b.dataset.quick;
        if (q === "collection") { KD.go("collection"); setTimeout(function () { KD.collection && KD.collection.addCards(); }, 150); }
        else KD.create.open({ mode: q });
      });
    });

    // recent decks + numbers
    D.loadDecks().then(function () { return D.loadPublished(); }).then(function () {
      paintRecent(view);
      var t = KD.$('[data-t="decks"]', view); if (t) t.textContent = KD.fmt(S.decks.length);
      D.hydrateDeckCounts().then(function (changed) { if (changed) paintRecent(view); });
    }).catch(function (e) {
      console.error(e);
      var box = KD.$("[data-recent]", view);
      if (box) box.innerHTML = '<div class="empty" style="grid-column:1/-1">' + KD.icon("alert") + "<p>Couldn't load your decks. Refresh to try again.</p></div>";
    });
    D.loadCollection().then(function () {
      var tot = D.collectionTotals();
      var c = KD.$('[data-t="cards"]', view), v = KD.$('[data-t="value"]', view);
      if (c) c.textContent = KD.fmt(tot.cards);
      if (v) v.textContent = KD.money(tot.value);
    }).catch(function () {});
    arenaSnapshot(KD.$("[data-arena-snap]", view));
  };

  function paintGensLine(el) {
    if (!el) return;
    var g = D.gens();
    el.classList.toggle("is-out", !g.unlimited && g.left <= 0);
    el.innerHTML = KD.icon("sparkle") + "<span>" + (g.unlimited ? "Unlimited builds" : g.left > 0 ? g.left + " free " + KD.plural(g.left, "build") + " this week" : "Free build used · " + esc(D.nextResetText(g) || "refills weekly")) + "</span>";
  }
  KD.paintGensLine = paintGensLine;

  function paintRecent(view) {
    var box = KD.$("[data-recent]", view);
    if (!box) return;
    var recent = (S.decks || []).slice(0, 4);
    if (!recent.length) {
      box.innerHTML = '<div class="empty panel" style="grid-column:1/-1">' + KD.icon("layers") +
        "<h3>No decks yet</h3><p>Describe one above and the Kraken builds it, or start one by hand.</p>" +
        '<button class="btn btn--ghost" type="button" data-create>' + KD.icon("plus") + "New deck</button></div>";
      return;
    }
    box.innerHTML = recent.map(function (d) { return KD.deckCard(d, S.published && S.published[d.id]); }).join("");
  }

  async function arenaSnapshot(host) {
    if (!host) return;
    try {
      var snap = await D.userRef().collection("assistantMatches").orderBy("endedAt", "desc").limit(3).get();
      if (snap.empty) return;
      var rows = snap.docs.map(function (d) { return Object.assign({ _id: d.id }, d.data()); });
      host.innerHTML = '<div class="shead"><h3>Latest Arena games</h3><a href="#/arena">All matches</a></div>' +
        '<div class="panel arows">' + rows.map(function (m) { return KD.matchRow(m); }).join("") + "</div>";
    } catch (e) { /* no Arena history is the common case */ }
  }
})();
